import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import { updateAirframePowerplantField } from "../helpers/airframePowerplantApi";

/**
 * AirframePowerplantPage
 *
 * Displays aircraft inspection, airframe, powerplant, propeller,
 * certificate, and equipment information in a table layout.
 */
export default function AirframePowerplantPage({
  currentAircraft,
  setCurrentAircraft,
}) {
  const [annualAirframeInspectionDate, setAnnualAirframeInspectionDate] = useState("");
  const [annualAirframeCompletedDate, setAnnualAirframeCompletedDate] = useState("");

  const [annualPowerplantInspectionDate, setAnnualPowerplantInspectionDate] = useState("");
  const [annualPowerplantCompletedDate, setAnnualPowerplantCompletedDate] = useState("");

  const [annualPropellerInspectionDate, setAnnualPropellerInspectionDate] = useState("");
  const [annualPropellerCompletedDate, setAnnualPropellerCompletedDate] = useState("");

  const [altimeterInspectionDate, setAltimeterInspectionDate] = useState("");
  const [altimeterCompletedDate, setAltimeterCompletedDate] = useState("");

  const [transponderInspectionDate, setTransponderInspectionDate] = useState("");
  const [transponderCompletedDate, setTransponderCompletedDate] = useState("");

  const [eltInspectionDate, setEltInspectionDate] = useState("");
  const [eltCompletedDate, setEltCompletedDate] = useState("");

  const [engineOverhaulDate, setEngineOverhaulDate] = useState("");

  const [vorInspectionDate, setVorInspectionDate] = useState("");
  const [vorCompletedDate, setVorCompletedDate] = useState("");

  const selectedAircraft = currentAircraft || {};

  console.log("CURRENT AIRCRAFT:", currentAircraft);
  console.log("AIRFRAME DATA:", currentAircraft?.airframePowerplant);

  async function updateAirframePowerplant(rowKey, field, value) {
    if (!selectedAircraft?.tailNumber) {
      return;
    }

    setCurrentAircraft((prev) => ({
      ...prev,
      airframePowerplant: {
        ...(prev.airframePowerplant || {}),
        [rowKey]: {
          ...(prev.airframePowerplant?.[rowKey] || {}),
          [field]: value,
        },
      },
    }));

    try {

      console.log("updateAirframePowerplant called:", {
        tailNumber: selectedAircraft?.tailNumber,
        rowKey,
        field,
        value,
      });
      await updateAirframePowerplantField({
        airplaneId: selectedAircraft.tailNumber,
        rowKey,
        field,
        value,
      });
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
  const data = selectedAircraft?.airframePowerplant || {};

  setAnnualAirframeInspectionDate(data.annualAirframe?.dateDue || "");
  setAnnualAirframeCompletedDate(data.annualAirframe?.dateCompleted || "");

  setAnnualPowerplantInspectionDate(data.annualPowerplant?.dateDue || "");
  setAnnualPowerplantCompletedDate(data.annualPowerplant?.dateCompleted || "");

  setAnnualPropellerInspectionDate(data.annualPropeller?.dateDue || "");
  setAnnualPropellerCompletedDate(data.annualPropeller?.dateCompleted || "");

  setAltimeterInspectionDate(data.altimeterSystem?.dateDue || "");
  setAltimeterCompletedDate(data.altimeterSystem?.dateCompleted || "");

  setTransponderInspectionDate(data.transponder?.dateDue || "");
  setTransponderCompletedDate(data.transponder?.dateCompleted || "");

  setEltInspectionDate(data.elt?.dateDue || "");
  setEltCompletedDate(data.elt?.dateCompleted || "");

  setVorInspectionDate(data.vorCheck?.dateDue || "");
  setVorCompletedDate(data.vorCheck?.dateCompleted || "");

  setEngineOverhaulDate(data.engineOverhaul?.date || "");

}, [selectedAircraft?.tailNumber, selectedAircraft?.airframePowerplant]);

      console.log(
        "AIRFRAME DATA:",
        selectedAircraft?.airframePowerplant
      );
  return (
    <>
    {/* ============================================================
                RELATED TOOLS / INTERNAL LINKS
                ============================================================ */}

        <div className="related-links">
        
          <Link to="/density-altitude">Density Altitude</Link> |
          <Link to="/cw">Crosswind/Headwind</Link> |
          <Link to="/mnvr">Maneuvers</Link> |
          <Link to="/airplane-prebuy">Airplane Prebuy Checklist</Link>
        </div>
     {/* ============================================================
        INTRO SECTION.   Note: this requires a react fragment wrapper to work with the existing 
        header and nav components.   <></>
        ============================================================ */}
   
      <div className="home-hero">
      <p>
          Before using this table,  go to the home page and select an aircraft 
          or create new aircraft.
        </p>
         <h2 style={{ fontSize: "20px", marginTop: "10px" }}>
            Selected Aircraft:
          </h2>
          <p
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: "darkblue",
                marginTop: "4px",
              }}
            >
              {selectedAircraft?.tailNumber || "No Aircraft Selected"}

              {selectedAircraft?.makeModel
                ? ` — ${selectedAircraft.makeModel}`
                : ""}
            </p>
        </div>
   
    <main className="airframe-powerplant-page">
      <section className="airframe-powerplant-card">
        <h2 style={{ textAlign: "left" }}>
          Airframe & Powerplant Information & Radios
        </h2>

        <table className="airframe-powerplant-table">
          <thead>
            <tr>
              <th>14CFR</th>
              <th>Requirements</th>
              <th>Date Due</th>
              <th>Date Completed</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>91.409a</td>
              <td>Annual Inspection: Airframe</td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.annualAirframe?.dateDue ||
                    annualAirframeInspectionDate
                  }
                  onChange={(e) => {
                    setAnnualAirframeInspectionDate(e.target.value);
                    updateAirframePowerplant(
                      "annualAirframe",
                      "dateDue",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.annualAirframe?.dateCompleted ||
                    annualAirframeCompletedDate
                  }
                  onChange={(e) => {
                    setAnnualAirframeCompletedDate(e.target.value);
                    updateAirframePowerplant(
                      "annualAirframe",
                      "dateCompleted",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>
            </tr>

            <tr>
              <td>91.409a</td>
              <td>Annual Inspection: Powerplant</td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.annualPowerplant?.dateDue ||
                    annualPowerplantInspectionDate
                  }
                  onChange={(e) => {
                    setAnnualPowerplantInspectionDate(e.target.value);
                    updateAirframePowerplant(
                      "annualPowerplant",
                      "dateDue",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.annualPowerplant?.dateCompleted ||
                    annualPowerplantCompletedDate
                  }
                  onChange={(e) => {
                    setAnnualPowerplantCompletedDate(e.target.value);
                    updateAirframePowerplant(
                      "annualPowerplant",
                      "dateCompleted",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>
            </tr>

            <tr>
              <td>91.409a</td>
              <td>Annual Inspection: Propeller</td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.annualPropeller?.dateDue ||
                    annualPropellerInspectionDate
                  }
                  onChange={(e) => {
                    setAnnualPropellerInspectionDate(e.target.value);
                    updateAirframePowerplant(
                      "annualPropeller",
                      "dateDue",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.annualPropeller?.dateCompleted ||
                    annualPropellerCompletedDate
                  }
                  onChange={(e) => {
                    setAnnualPropellerCompletedDate(e.target.value);
                    updateAirframePowerplant(
                      "annualPropeller",
                      "dateCompleted",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>
            </tr>

            <tr>
              <td>91.411</td>
              <td>Altimeter system and altitude reporting equipment (IFR)</td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.altimeterSystem?.dateDue ||
                    altimeterInspectionDate
                  }
                  onChange={(e) => {
                    setAltimeterInspectionDate(e.target.value);
                    updateAirframePowerplant(
                      "altimeterSystem",
                      "dateDue",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.altimeterSystem?.dateCompleted ||
                    altimeterCompletedDate
                  }
                  onChange={(e) => {
                    setAltimeterCompletedDate(e.target.value);
                    updateAirframePowerplant(
                      "altimeterSystem",
                      "dateCompleted",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>
            </tr>

            <tr>
              <td>91.413</td>
              <td>ATC Transponder</td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.transponder?.dateDue ||
                    transponderInspectionDate
                  }
                  onChange={(e) => {
                    setTransponderInspectionDate(e.target.value);
                    updateAirframePowerplant(
                      "transponder",
                      "dateDue",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.transponder?.dateCompleted ||
                    transponderCompletedDate
                  }
                  onChange={(e) => {
                    setTransponderCompletedDate(e.target.value);
                    updateAirframePowerplant(
                      "transponder",
                      "dateCompleted",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>
            </tr>

            <tr>
              <td>91.207</td>
              <td>Emergency Locator Transmitter - ELT</td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.elt?.dateDue ||
                    eltInspectionDate
                  }
                  onChange={(e) => {
                    setEltInspectionDate(e.target.value);
                    updateAirframePowerplant(
                      "elt",
                      "dateDue",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.elt?.dateCompleted ||
                    eltCompletedDate
                  }
                  onChange={(e) => {
                    setEltCompletedDate(e.target.value);
                    updateAirframePowerplant(
                      "elt",
                      "dateCompleted",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>
            </tr>

            <tr>
              <td>91.171</td>
              <td>VOR Equipment Check - 30 days (See VOR sheet)</td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.vorCheck?.dateDue ||
                    vorInspectionDate
                  }
                  onChange={(e) => {
                    setVorInspectionDate(e.target.value);
                    updateAirframePowerplant(
                      "vorCheck",
                      "dateDue",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>

              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.vorCheck?.dateCompleted ||
                    vorCompletedDate
                  }
                  onChange={(e) => {
                    setVorCompletedDate(e.target.value);
                    updateAirframePowerplant(
                      "vorCheck",
                      "dateCompleted",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>
            </tr>
          </tbody>
        </table>

        <h2 style={{ textAlign: "left" }}>
          Other inspections
        </h2>

        <table className="airframe-powerplant-table">
          <tbody>
            <tr>
              <td>
                <input
                  type="date"
                  value={
                    selectedAircraft?.airframePowerplant?.tachAtAnnual?.date ||
                    annualAirframeInspectionDate
                  }
                  onChange={(e) => {
                    setAnnualAirframeInspectionDate(e.target.value);
                    updateAirframePowerplant(
                      "tachAtAnnual",
                      "date",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>

              <td>Tach time at annual inspection</td>

              <td>
                <input
                  type="text"
                  value={
                    selectedAircraft?.airframePowerplant?.tachAtAnnual?.hours || ""
                  }
                  onChange={(e) =>
                    updateAirframePowerplant(
                      "tachAtAnnual",
                      "hours",
                      e.target.value
                    )
                  }
                  className="time-input"
                />
              </td>

              <td>hours</td>
            </tr>

            <tr>
              <td>
                <input
                  type="date"
                  name="engineOverhaulDate"
                  value={
                    selectedAircraft?.airframePowerplant?.engineOverhaul
                      ?.date || engineOverhaulDate
                  }
                  onChange={(e) => {
                    setEngineOverhaulDate(e.target.value);
                    updateAirframePowerplant(
                      "engineOverhaul",
                      "date",
                      e.target.value
                    );
                  }}
                  className="prebuy-date-input"
                />
              </td>

              <td>
                Engine overhaul date and time since last major overhaul.
              </td>

              <td>
                <input
                  type="text"
                  value={
                    selectedAircraft?.airframePowerplant?.engineOverhaul
                      ?.hours || ""
                  }
                   onChange={(e) =>
                    updateAirframePowerplant(
                      "engineOverhaul",
                      "hours",
                      e.target.value
                    )
                  }
                  className="time-input"
                />
              </td>

              <td>hours</td>
            </tr>

            <tr>
              <td>
                <input
                  type="date"
                  name="annualPropellerInspectionDate"
                  value={
                    selectedAircraft?.airframePowerplant?.propellerInfo
                      ?.date || ""
                  }
                  onChange={(e) =>
                    updateAirframePowerplant(
                      "propellerInfo",
                      "date",
                      e.target.value
                    )
                  }
                  className="prebuy-date-input"
                />
              </td>

              <td>
                Propeller MFR:
                <input
                  type="text"
                  value={
                    selectedAircraft?.airframePowerplant?.propellerInfo
                      ?.manufacturer || ""
                  }
                  onChange={(e) =>
                    updateAirframePowerplant(
                      "propellerInfo",
                      "manufacturer",
                      e.target.value
                    )
                  }
                  className="time-input"
                />
              </td>

              <td>
                Propeller Model:
                <input
                  type="text"
                  value={
                    selectedAircraft?.airframePowerplant?.propellerInfo
                      ?.model || ""
                  }
                  onChange={(e) =>
                    updateAirframePowerplant(
                      "propellerInfo",
                      "model",
                      e.target.value
                    )
                  }
                  className="time-input"
                />
              </td>
              <td></td>
            </tr>

            <tr>
              <td>
                <input
                  type="date"
                  name="annualPropellerInspectionDate"
                  value={
                    selectedAircraft?.airframePowerplant?.propOverhaul?.date ||
                    ""
                  }
                  onChange={(e) =>
                    updateAirframePowerplant(
                      "propOverhaul",
                      "date",
                      e.target.value
                    )
                  }
                  className="prebuy-date-input"
                />
              </td>

              <td>
                Prop overhaul date.&nbsp;&nbsp;&nbsp;Prop Time Hours.
              </td>

              <td>
                <input
                  type="text"
                  value={
                    selectedAircraft?.airframePowerplant?.propOverhaul
                      ?.hours || ""
                  }
                  onChange={(e) =>
                    updateAirframePowerplant(
                      "propOverhaul",
                      "hours",
                      e.target.value
                    )
                  }
                  className="time-input"
                />
              </td>

              <td>hours</td>
            </tr>

            <tr>
              <td>
                <input
                  type="date"
                  name="annualAirframeInspectionDate"
                   value={
                    selectedAircraft?.airframePowerplant?.totalTimeAirframe
                      ?.date || ""
                  }
                  onChange={(e) =>
                    updateAirframePowerplant(
                      "totalTimeAirframe",
                      "date",
                      e.target.value
                    )
                  }
                  className="prebuy-date-input"
                />
              </td>

              <td>Total Time Airframe</td>

              <td>
                <input
                  type="text"
                  value={
                    selectedAircraft?.airframePowerplant?.totalTimeAirframe
                      ?.hours || ""
                  }
                  onChange={(e) =>
                    updateAirframePowerplant(
                      "totalTimeAirframe",
                      "hours",
                      e.target.value
                    )
                  }
                  className="time-input"
                />
              </td>

              <td>hours</td>
            </tr>
          </tbody>
        </table>

        <h2 style={{ textAlign: "left" }}>
          Nameplate and serial number attached to the fuselage
        </h2>

        <table className="airframe-powerplant-table info-table">
  <tbody>
    <tr>
      <td>Model and Serial #</td>
      <td>
        <input
          type="text"
          className="time-input"
          value={
            selectedAircraft?.airframePowerplant?.nameplate?.modelSerial || ""
          }
          onChange={(e) =>
            updateAirframePowerplant(
              "nameplate",
              "modelSerial",
              e.target.value
            )
          }
        />
      </td>
    </tr>

    <tr>
      <td>Production Certificate</td>
      <td>
        <input
          type="text"
          className="time-input"
          value={
            selectedAircraft?.airframePowerplant?.nameplate
              ?.productionCertificate || ""
          }
          onChange={(e) =>
            updateAirframePowerplant(
              "nameplate",
              "productionCertificate",
              e.target.value
            )
          }
        />
      </td>
    </tr>

              <tr>
                <td>Type Certificate</td>
                <td>
                  <input
                    type="text"
                    className="time-input"
                    value={
                      selectedAircraft?.airframePowerplant?.nameplate
                        ?.typeCertificate || ""
                    }
                    onChange={(e) =>
                      updateAirframePowerplant(
                        "nameplate",
                        "typeCertificate",
                        e.target.value
                      )
                    }
                  />
                </td>
              </tr>

              <tr>
                <td>Engine Model</td>
                <td>
                  <input
                    type="text"
                    className="time-input"
                    value={
                      selectedAircraft?.airframePowerplant?.nameplate?.engineModel || ""
                    }
                    onChange={(e) =>
                      updateAirframePowerplant(
                        "nameplate",
                        "engineModel",
                        e.target.value
                      )
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>

           {/* ============================================================
                RELATED TOOLS / INTERNAL LINKS
                ============================================================ */}

        <div className="related-links">
          <Link to="/">Home</Link> |
          <Link to="/rollout">Ground Roll</Link> |
          <Link to="/navlog">NavLog</Link> |
          <Link to="/wtbals">Weight & Balance</Link> |
          <Link to="/density-altitude">Density Altitude</Link> |
          <Link to="/cw">Crosswind/Headwind</Link> |
          <Link to="/mnvr">Maneuvers</Link> |
          <Link to="/airplane-prebuy">Airplane Prebuy Checklist</Link>
        </div>
      </section>
    </main>
    </>
  );
}